import Cornerstone from "./Cornerstone/index.js";
import VTKjs from "./VTKjs/index.js";
import DICOMMicroscopyViewer from "./DICOMMicroscopyViewer/";

const adapters = {
    Cornerstone,
    VTKjs,
    DICOMMicroscopyViewer
};

export default adapters;
